import { makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import { DsFooter, getDividedLinks, getGroupLinks } from "@mvp/design-system";
import React from "react";
import { sharedUrls } from "../sharedURLs";

const useStyles = makeStyles((theme) => ({
  mobilePadding: {
    // Add padding at the bottom of the page on mobile view since plan overview is fixed at the bottom.
    [theme.breakpoints.down('sm')]: {
      height: '140px',
    },
  },
}));

export const Footer = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));
  const groupLinks = isMobileView ? [] : getGroupLinks(sharedUrls.wwwRoot);
  const dividedLinks = getDividedLinks(sharedUrls.wwwRoot);

  return (
    <>
      <DsFooter groupLinks={groupLinks} dividedLinks={dividedLinks} />
      <div className={classes.mobilePadding} />
    </>
  );
};